export default __webpack_public_path__ + "static/media/home-interior-design-about-img03.e5788190.jpg";